import { create } from "zustand";

export const useTapState = create((set, get) => ({
    state: null,
    active: true,
    setTapState: (options) => set({state: {x: options?.x ?? null, y: options?.y ?? null}}),
    enable: () => set(prev => ({...prev, active: true})),
    disable: () => set(prev => ({...prev, active: false})),
    toggle: (newState = null) => set(prev => ({...prev, active: newState ?? !prev.active})),
    getLastTabPosition: () => get().state,
    clearTapState: () => set({state: null})
}));